module.exports = __webpack_public_path__ + "media/images/iconSocialMail__accent--dark-2b8a1c3eb257ff888c989bb4e9ecfad4.png";